import callApi from './apiActions'

export const requestLocations = () => {
    return dispatch => {
        dispatch({ type: 'REQUEST_LOCATIONS' })

        return dispatch(callApi('get', 'locations'))
            .then(data => {
                dispatch({
                    type: 'REQUEST_LOCATIONS_SUCCESS',
                    payload: data.payload
                })
            })
            .catch(err => {
                dispatch({ type: 'REQUEST_LOCATIONS_FAIL' })
            })
    }
}

export const requestLocationsUser = (privateLink) => {
    return dispatch => {
        dispatch({ type: 'REQUEST_LOCATIONS' })

        return dispatch(callApi('get', `user/locations/${privateLink}`, null, true))
            .then(data => {
                dispatch({
                    type: 'REQUEST_LOCATIONS_SUCCESS_USER',
                    payload: data.payload,
                    privateLink: privateLink
                })
            })
            .catch(err => {
                dispatch({ type: 'REQUEST_LOCATIONS_FAIL' })
            })
    }
}

// Chainable, have to .catch errors
export const updateLocation = location => {
    return dispatch => {
        return dispatch(callApi('put', `locations/${location.app_id}`, { location }))
            .then(data => {
                dispatch({
                    type: 'UPDATE_LOCATION',
                    payload: location
                })
            }).catch(err => {
                throw err
            })
    }
}


// WEBPACK FOOTER //
// ./src/actions/locationsActions.js